<template lang="pug">
  VuePerfectScrollbar.MainContainer(
    :style="containerStyle"
    :settings="perfectScrollbarSettings"
    :swicher="!isPageTransitioning"
    ref="scroller"
  )
    PageTransitionLayer.MainContainer_transitionLayer.MainContainer_transitionLayer-betweenPage(v-if="!hasCustomTransition && isPageTransitioning")
    transition(
      appear
      v-on:before-leave="beforePageLeave"
      v-on:leave="pageLeave"
      v-on:enter="pageEnter"
      v-on:after-enter="afterPageEnter"
      v-bind:css="false")
      router-view(ref="currentView", :key="key", :data-key="key")
</template>

<script>

import Vue from 'vue'
import PageTransitionLayer from '@/components/PageTransitionLayer'
import {TweenLite} from 'gsap'
import store from '@/store'
import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    PageTransitionLayer,
    VuePerfectScrollbar
  },
  data () {
    return {
      isFullscreenRoute: false,
      hasCustomTransition: false,
      transitionSpeed: 1.2
    }
  },
  computed: {
    ...mapGetters([
      'isPageTransitioning',
      'viewportSize'
    ]),
    key () {
      if (this.$route.name === 'search') return 'key-home'
      return 'key-' + this.$route.name || 'key'
    },
    perfectScrollbarSettings () {
      return {
        suppressScrollY: this.isFullscreenRoute,
        suppressScrollX: true,
        wheelSpeed: 2
      }
    },
    containerStyle () {
      return {
        height: this.viewportSize.height + 'px'
      }
    }
  },
  watch: {
    isPageTransitioning () {
      // A la fin d'une transition
      if (!this.isPageTransitioning) {
        // S'il y a une ancienne page
        if (this._oldViewDoneCallback) {
          // alors on appel son callback pour afin de la retirer
          this._oldViewDoneCallback()
        }
      }
    },
    $route () {
      this.updateIsFullscreenRoute()
    }
  },
  mounted () {
    this.$parallax.active()
    this.updateIsFullscreenRoute()
  },
  methods: {
    /**
     * Update isFullscreenRoute en fonction de la $route actuel
     */
    updateIsFullscreenRoute () {
      // Liste des routes qui sont fullscreen
      const fullscreenRoutes = ['home']

      this.isFullscreenRoute = fullscreenRoutes.indexOf(this.$route.name) > -1
    },
    /**
     * Callback avant que l'ancienne page disparaissent
     */
    beforePageLeave (pEl) {
      // On définit qu'on est en transition de page
      store.dispatch('setIsPageTransitioning', true)

      // On place l'ancienne page en bas du stack
      TweenLite.set(pEl, {
        zIndex: 0,
        position: 'absolute',
        top: -this.$el.scrollTop, // on garde son scroll actuel
        left: 0,
        width: '100%',
        minHeight: this.viewportSize.height + 'px'
      })

      // On reset le scroll du container
      // et on empêche le scroll
      TweenLite.set(this.$el, {
        scrollTop: 0,
        overflowY: 'hidden'
      })
    },
    /**
     * Callback lorsque l'ancienne page disparait
     */
    pageLeave (pEl, done) {
      // On sauvegarde le callback permettant du supprimer la page du dom
      // afin de l'appeler quand l'animation d'apparition de la nouvelle page sera terminée
      // cela permet de laisser l'ancienne page en dessous pendant la transition
      this._oldViewDoneCallback = done
    },
    /**
     * Callback lorsque la nouvelle page s'affiche
     */
    pageEnter (pEl, done) {
      const {currentView} = this.$refs

      // Si la page à une méthode playIn permettant de gérer sa transition
      if (currentView.transitionInPromise) {
        // On défini que c'est une animation custom
        this.hasCustomTransition = true

        // On joue la transition custom
        // puis on appel "done" une fois celle-ci finie
        currentView.transitionInPromise().then(done)
      }
      // S'il n'y  a pas de transition custom de définie
      // On applique un simple fadeIn
      else {
        // On défini que ce n'est pas une animation custom
        this.hasCustomTransition = false

        // On la cache et la place au dessus du stack
        TweenLite.set(pEl, {
          zIndex: 2,
          position: 'relative',
          opacity: 0
        })

        // On la fait apparaître en fadeIn
        TweenLite.to(pEl, 2, {
          opacity: 1,
          delay: 1,
          onComplete: done // on continue
        })
      }
    },
    /**
     * Callback après l'apparition de la nouvelle page
     */
    afterPageEnter (pEl) {
      // On supprime les propriétés css maintenant obseletes
      TweenLite.set(pEl, {
        clearProps: 'opacity,zIndex,position'
      })

      // et on réactive le scroll
      TweenLite.set(this.$el, {
        clearProps: 'overflowY'
      })

      // On définit qu'on est plus en transition de page
      store.dispatch('setIsPageTransitioning', false)
    }
  }
}
</script>

<style lang="stylus" scoped>

.MainContainer
  z-index 0
  position fixed
  top 0
  left 0
  width 'calc(100vw - %s)' % $menu_bar_width_mobile
  margin-left $menu_bar_width_mobile
  height 100vh
  overflow-x hidden
  overflow-y auto

  @media $mq_m
    width 'calc(100vw - %s)' % $menu_bar_width
    margin-left $menu_bar_width

  &_transitionLayer
    //
    &-betweenPage
      z-index 1

</style>
